<template>
  <div>
    <RestrictionCard class="mb-4" :restriction="restriction" />
    <v-btn outlined @click="previousStep">
      <v-icon class="mr-3">mdi-arrow-left</v-icon>
      {{ getLabel("back") }}
    </v-btn>
    <v-btn color="success" class="ml-2" @click="finalStep()">
      <v-icon class="mr-3">mdi-content-save</v-icon>
      {{ getLabel("save") }}
    </v-btn>
  </div>
</template>

<script>
import { getLabel } from '@/utils/index';

import RestrictionCard from '@/components/UI/RestrictionCard.vue';

export default {
  components: { RestrictionCard },
  props: {
    restriction: {
      type: Object,
      required: true
    }
  },
  setup (props, { emit }) {
    const previousStep = () => {
      emit('previousStep');
    };

    const finalStep = () => {
      emit('saveRestriction');
    };

    return { getLabel, previousStep, finalStep };
  }

};
</script>
